// 设置cookie
var setCookie = function (name, value, min) {
  var exdate = new Date()
  exdate.setTime(exdate.getTime() + min * 60 * 1000)
  document.cookie = name + '=' + escape(value) +
    ((min == null) ? '' : ';expires=' + exdate.toGMTString()) + ';path=/;'
}

// 获取cookie
var getCookie = function (name) {
  if (document.cookie.length > 0) {
    var cookstart = document.cookie.indexOf(name + '=')
    if (cookstart !== -1) {
      cookstart = cookstart + name.length + 1
      var cookend = document.cookie.indexOf(';', cookstart)
      if (cookend === -1) cookend = document.cookie.length
      return unescape(document.cookie.substring(cookstart, cookend))
    }
  }
  return ''
}
// 删除cookie
var deleteCookie = function (name) {
  var exdate = new Date()
  exdate.setTime(exdate.getTime() - 1)
  document.cookie = name + '= ' + '; expires=' + exdate.toGMTString() + ';path=/;'
}
export default {
  setCookie,
  getCookie,
  deleteCookie
  // deleteCookie
}
